import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

import Login from "@/pages/Dashboard/Pages/Login.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";

import User from "@/pages/Dashboard/Pages/UserProfile.vue";

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "me",
      name: "User Page",
      components: { default: User }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresVisitor: true
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        requiresVisitor: true
      }
    }
  ]
};

let userPages = {
  path: "/users",
  component: DashboardLayout,
  name: "Users",
  redirect: "/users/student",
  children: [
    {
      path: "admin",
      name: "Admin Users",
      component: () =>
        import(
          /* webpackChunkName: "admin_user" */ "@/pages/Dashboard/User/AdminUsers.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "student",
      name: "Student Users",
      component: () =>
        import(
          /* webpackChunkName: "student_user" */ "@/pages/Dashboard/User/StudentUsers.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "university",
      name: "University Users",
      component: () =>
        import(
          /* webpackChunkName: "university_user" */ "@/pages/Dashboard/User/UniversityUsers.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "agency",
      name: "Agency Users",
      component: () =>
        import(
          /* webpackChunkName: "agency_user" */ "@/pages/Dashboard/User/AgencyUsers.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "dorm",
      name: "Dorm Users",
      component: () =>
        import(
          /* webpackChunkName: "dorm_user" */ "@/pages/Dashboard/User/DormUsers.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "user/student/create",
      name: "User Create",
      component: () =>
        import(
          /* webpackChunkName: "student_user_create" */ "@/pages/Dashboard/User/UserUpsert.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "student"
      }
    },
    {
      path: "user/admin/create",
      name: "Admin User Create",
      component: () =>
        import(
          /* webpackChunkName: "admin_user_create" */ "@/pages/Dashboard/User/UserStaffCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "admin"
      }
    },
    {
      path: "user/university/create",
      name: "University User Create",
      component: () =>
        import(
          /* webpackChunkName: "university_user_create" */ "@/pages/Dashboard/User/UserStaffCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "university"
      }
    },
    {
      path: "user/agency/create",
      name: "Agency User Create",
      component: () =>
        import(
          /* webpackChunkName: "agency_user_create" */ "@/pages/Dashboard/User/UserStaffCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "agency"
      }
    },
    {
      path: "user/dorm/create",
      name: "Dorm User Create",
      component: () =>
        import(
          /* webpackChunkName: "dorm_user_create" */ "@/pages/Dashboard/User/UserStaffCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "dorm"
      }
    },
    {
      path: "user/student/:id",
      name: "Student User Update",
      component: () =>
        import(
          /* webpackChunkName: "student_user_update" */ "@/pages/Dashboard/User/UserStudentUpdate.vue"
        ),
      meta: {
        requiresAuth: true,
        update: true
      }
    },
    {
      path: "user/admin/:id",
      name: "Admin User Update",
      component: () =>
        import(
          /* webpackChunkName: "admin_user_update" */ "@/pages/Dashboard/User/UserStaffUpdate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "admin",
        update: true
      }
    },
    {
      path: "user/university/:id",
      name: "University User Update",
      component: () =>
        import(
          /* webpackChunkName: "university_user_update" */ "@/pages/Dashboard/User/UserStaffUpdate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "university",
        update: true
      }
    },
    {
      path: "user/agency/:id",
      name: "Agency User Update",
      component: () =>
        import(
          /* webpackChunkName: "agency_user_update" */ "@/pages/Dashboard/User/UserStaffUpdate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "agency",
        update: true
      }
    },
    {
      path: "user/dorm/:id",
      name: "Dorm User Update",
      component: () =>
        import(
          /* webpackChunkName: "dorm_user_update" */ "@/pages/Dashboard/User/UserStaffUpdate.vue"
        ),
      meta: {
        requiresAuth: true,
        staff: "dorm",
        update: true
      }
    }
  ]
};

let universityPages = {
  path: "/university",
  component: DashboardLayout,
  name: "University",
  redirect: "/university/list",
  children: [
    {
      path: "list",
      name: "University List",
      component: () =>
        import(
          /* webpackChunkName: "university" */ "@/pages/Dashboard/University/UniversityList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "create",
      name: "University Create",
      component: () =>
        import(
          /* webpackChunkName: "university_create" */ "@/pages/Dashboard/University/UniversityCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "update/:id",
      name: "University Update",
      component: () =>
        import(
          /* webpackChunkName: "university_update" */ "@/pages/Dashboard/University/UniversityUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "programs/list",
      name: "Program List",
      component: () =>
        import(
          /* webpackChunkName: "program" */ "@/pages/Dashboard/University/ProgramList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "programs/create",
      name: "Program Create",
      component: () =>
        import(
          /* webpackChunkName: "program_create" */ "@/pages/Dashboard/University/ProgramCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "programs/update/:id",
      name: "Program Update",
      component: () =>
        import(
          /* webpackChunkName: "program_update" */ "@/pages/Dashboard/University/ProgramUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "announcement/list",
      name: "Announcement List",
      component: () =>
        import(
          /* webpackChunkName: "announcement_list" */ "@/pages/Dashboard/Announcement/AnnouncementList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "announcement/create",
      name: "Announcement Create",
      component: () =>
        import(
          /* webpackChunkName: "announcement_create" */ "@/pages/Dashboard/Announcement/AnnouncementCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "announcement/update/:id",
      name: "Announcement Update",
      component: () =>
        import(
          /* webpackChunkName: "announcement_update" */ "@/pages/Dashboard/Announcement/AnnouncementUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let applicationPages = {
  path: "/application",
  component: DashboardLayout,
  name: "Application",
  redirect: "/application/list",
  children: [
    {
      path: "missing_list",
      name: "Missing Documents Application List",
      component: () =>
        import(
          /* webpackChunkName: "application_list" */ "@/pages/Dashboard/Application/ApplicationList.vue"
        ),
      meta: {
        requiresAuth: true,
        query: "missing_list"
      }
    },
    {
      path: "decline_list",
      name: "Decline/Rejected Application List",
      component: () =>
        import(
          /* webpackChunkName: "application_list" */ "@/pages/Dashboard/Application/ApplicationList.vue"
        ),
      meta: {
        requiresAuth: true,
        query: "decline_list"
      }
    },
    {
      path: "waiting_approve_list",
      name: "Waiting Approve List",
      component: () =>
        import(
          /* webpackChunkName: "application_list" */ "@/pages/Dashboard/Application/ApplicationList.vue"
        ),
      meta: {
        requiresAuth: true,
        query: "waiting_approve"
      }
    },
    {
      path: "waiting_application_list",
      name: "Waiting Application List",
      component: () =>
        import(
          /* webpackChunkName: "application_list" */ "@/pages/Dashboard/Application/ApplicationList.vue"
        ),
      meta: {
        requiresAuth: true,
        query: "waiting_application"
      }
    },
    {
      path: "applied_list",
      name: "Applied Application List",
      component: () =>
        import(
          /* webpackChunkName: "application_list" */ "@/pages/Dashboard/Application/ApplicationList.vue"
        ),
      meta: {
        requiresAuth: true,
        query: "applied_application"
      }
    },
    {
      path: "list",
      name: "Application List",
      component: () =>
        import(
          /* webpackChunkName: "application_list" */ "@/pages/Dashboard/Application/ApplicationList.vue"
        ),
      meta: {
        requiresAuth: true,
        query: "all"
      }
    },
    {
      path: "create/:user_id/:user_name",
      name: "Application Create",
      component: () =>
        import(
          /* webpackChunkName: "application_create" */ "@/pages/Dashboard/Application/ApplicationCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "update/:application_id",
      name: "Application Update",
      component: () =>
        import(
          /* webpackChunkName: "application_update" */ "@/pages/Dashboard/Application/ApplicationUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "season/list",
      name: "Season List",
      component: () =>
        import(
          /* webpackChunkName: "season_list" */ "@/pages/Dashboard/Application/SeasonList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "season/create/",
      name: "Season Create",
      component: () =>
        import(
          /* webpackChunkName: "season_create" */ "@/pages/Dashboard/Application/SeasonCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "season/update/:id",
      name: "Season Update",
      component: () =>
        import(
          /* webpackChunkName: "season_update" */ "@/pages/Dashboard/Application/SeasonUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let dormPages = {
  path: "/dorm",
  component: DashboardLayout,
  name: "Dorm",
  redirect: "/dorm/list",
  children: [
    {
      path: "list",
      name: "Dorm List",
      component: () =>
        import(
          /* webpackChunkName: "dorm_list" */ "@/pages/Dashboard/Dorm/DormList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "create",
      name: "Dorm Create",
      component: () =>
        import(
          /* webpackChunkName: "dorm_create" */ "@/pages/Dashboard/Dorm/DormCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "update/:id",
      name: "Dorm Update",
      component: () =>
        import(
          /* webpackChunkName: "dorm_update" */ "@/pages/Dashboard/Dorm/DormUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let agencyPages = {
  path: "/agency",
  component: DashboardLayout,
  name: "Agency",
  redirect: "/agency/list",
  children: [
    {
      path: "list",
      name: "Agency List",
      component: () =>
        import(
          /* webpackChunkName: "agency_list" */ "@/pages/Dashboard/Agency/AgencyList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "create",
      name: "Agency Create",
      component: () =>
        import(
          /* webpackChunkName: "agency_create" */ "@/pages/Dashboard/Agency/AgencyCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "update/:id",
      name: "Agency Update",
      component: () =>
        import(
          /* webpackChunkName: "agency_update" */ "@/pages/Dashboard/Agency/AgencyUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "commission/list",
      name: "Commission List",
      component: () =>
        import(
          /* webpackChunkName: "commission_list" */ "@/pages/Dashboard/Agency/CommissionList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "commission/create",
      name: "Commission Create",
      component: () =>
        import(
          /* webpackChunkName: "commission_create" */ "@/pages/Dashboard/Agency/CommissionCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "commission/update/:id",
      name: "Commission Update",
      component: () =>
        import(
          /* webpackChunkName: "commission_update" */ "@/pages/Dashboard/Agency/CommissionUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let locationPages = {
  path: "/location",
  component: DashboardLayout,
  name: "Location",
  redirect: "/location/country/list",
  children: [
    {
      path: "country/list",
      name: "Country List",
      component: () =>
        import(
          /* webpackChunkName: "country" */ "@/pages/Dashboard/Location/CountryList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "country/create",
      name: "Country Create",
      component: () =>
        import(
          /* webpackChunkName: "country_create" */ "@/pages/Dashboard/Location/CountryCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "country/update/:id",
      name: "Country Update",
      component: () =>
        import(
          /* webpackChunkName: "country_update" */ "@/pages/Dashboard/Location/CountryUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "city/list",
      name: "City List",
      component: () =>
        import(
          /* webpackChunkName: "city" */ "@/pages/Dashboard/Location/CityList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "city/create",
      name: "City Create",
      component: () =>
        import(
          /* webpackChunkName: "city_create" */ "@/pages/Dashboard/Location/CityCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "city/update/:id",
      name: "City Update",
      component: () =>
        import(
          /* webpackChunkName: "city_update" */ "@/pages/Dashboard/Location/CityUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "place/list",
      name: "Place List",
      component: () =>
        import(
          /* webpackChunkName: "place" */ "@/pages/Dashboard/Location/PlaceList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "transportation/list",
      name: "Transportation List",
      component: () =>
        import(
          /* webpackChunkName: "transportation" */ "@/pages/Dashboard/Location/TransportationList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let candidatePages = {
  path: "/candidate-form",
  component: DashboardLayout,
  name: "Candidate",
  redirect: "/candidate-form/list",
  children: [
    {
      path: "list",
      name: "Candidate List",
      component: () =>
        import(
          /* webpackChunkName: "candidate_list" */ "@/pages/Dashboard/Candidate/CandidateList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "finished-list",
      name: "Candidate Finished List",
      component: () =>
        import(
          /* webpackChunkName: "candidate_list" */ "@/pages/Dashboard/Candidate/CandidateFinishedList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "create",
      name: "Candidate Create",
      component: () =>
        import(
          /* webpackChunkName: "candidate_create" */ "@/pages/Dashboard/Candidate/CandidateCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "update/:id",
      name: "Candidate Update",
      component: () =>
        import(
          /* webpackChunkName: "candidate_update" */ "@/pages/Dashboard/Candidate/CandidateUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let ArticlePages = {
  path: "/article",
  component: DashboardLayout,
  name: "Article",
  redirect: "/article/list",
  children: [
    {
      path: "list",
      name: "Article List",
      component: () =>
        import(
          /* webpackChunkName: "article_list" */ "@/pages/Dashboard/Article/ArticleList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "create",
      name: "Article Create",
      component: () =>
        import(
          /* webpackChunkName: "article_create" */ "@/pages/Dashboard/Article/ArticleCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "update/:id",
      name: "Article Update",
      component: () =>
        import(
          /* webpackChunkName: "article_update" */ "@/pages/Dashboard/Article/ArticleUpdate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  authPages,
  universityPages,
  pagesMenu,
  userPages,
  applicationPages,
  locationPages,
  dormPages,
  agencyPages,
  candidatePages,
  ArticlePages,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
